import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { withTranslation } from "react-i18next";

class DataEntryEditStockInword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
 
    document.title = "data entry person";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                  <div className="d-lg-flex d-block justify-content-between">
                  <div>
                    <h4 className="pb-3 text-black fw-bold">{this.props.t('Edit Stock (Inward)')}</h4>
                    </div>
                    {/* <div>
                      <label htmlFor="date" className="pe-2 fs-5 fw-bold text-black">Date:</label>
                      <input type="date" className="fs-5 border-0 text-black" />
                    </div> */}
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        stockID: (this.state && this.state.stockID) || "",
                        partyCode:
                          (this.state && this.state.partyCode) || "",
                        unitName: (this.state && this.state.unitName) || "",
                        weight: (this.state && this.state.weight) || "",
                        pieces: (this.state && this.state.pieces) || "",
                        graderName:
                          (this.state && this.state.graderName) || "",
                        inward: (this.state && this.state.inward) || "",
                      }}
                      validationSchema={Yup.object().shape({
                        attachment: Yup.mixed()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value =>
                              !value || (value && value.size <= FILE_SIZE)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value && SUPPORTED_FORMATS.includes(value.type))
                          ),
                        stockID: Yup.string().required(
                          "This Value is Required"
                        ),
                        partyCode: Yup.string().required(
                          "This Value is Required"
                        ),
                        unitName: Yup.string().required(
                          "This Value is Required"
                        ),
                        weight: Yup.string().required("This Value is Required"),
                        pieces: Yup.string().required("This Value is Required"),
                        graderName: Yup.string().required(
                          "This Value is Required"
                        ),
                        inward: Yup.string().required("This Value is Required"),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="stockID"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t('Stock ID')}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.stockID && touched.stockID
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="stockID"
                                  placeholder="JANGAD0000123"
                                />
                                <ErrorMessage
                                  name="stockID"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t('Party Code')}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="partyCode"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="unitName"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                Unit Name
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.unitName && touched.unitName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="unitName"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="xyz">ABC Diamond Unit</option>
                                  <option value="xyz">
                                  ABC Diamond Unit
                                  </option>
                                  <option value="xyz">
                                  ABC Diamond Unit
                                  </option>
                                  <option value="xyz">
                                  ABC Diamond Unit
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="unitName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="weight"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t("Total Weight")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.weight && touched.weight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="weight"
                                  placeholder="20.25 CT"
                                />
                                <ErrorMessage
                                  name="weight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="pieces"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t('Total No of Pieces')}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.pieces && touched.pieces
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="pieces"
                                  placeholder="01%"
                                />
                                <ErrorMessage
                                  name="pieces"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="graderName"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t("Grader Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.graderName && touched.graderName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="graderName"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="grader1">Grader 1</option>
                                  <option value="grader2">
                                  Grader 2
                                  </option>
                                  <option value="grader3">
                                  Grader 3
                                  </option>
                                  <option value="grader4">
                                  Grader 4
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="graderName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="inward"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                Self Internal Remarks
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.inward && touched.inward
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="inward"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="inward"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                              >
                                Submit
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(DataEntryEditStockInword);